export default {
  scheduler: 'מתזמן',
  'scheduler.info': 'פרטי מתזמן',
  'scheduler.header.title': 'מתזמן {{entity}} ({{count}})',
  'scheduler.result': 'מתרחש <strong>{{occurs}}</strong>, החל מ־{{startAt}}.',
  'scheduler.startedAt': 'התחיל ב־',
  'scheduler.duration': 'חזור כל',
  'scheduler.occurrences': 'הופעות',
  'scheduler.weekdays.sunday': 'ראשון',
  'scheduler.weekdays.monday': 'שני',
  'scheduler.weekdays.tuesday': 'שלישי',
  'scheduler.weekdays.wednesday': 'רביעי',
  'scheduler.weekdays.thursday': 'חמישי',
  'scheduler.weekdays.friday': 'שישי',
  'scheduler.weekdays.saturday': 'שבת',
  'scheduler.weekdays.short.sunday': 'א',
  'scheduler.weekdays.short.monday': 'ב',
  'scheduler.weekdays.short.tuesday': 'ג',
  'scheduler.weekdays.short.wednesday': 'ד',
  'scheduler.weekdays.short.thursday': 'ה',
  'scheduler.weekdays.short.friday': 'ו',
  'scheduler.weekdays.short.saturday': 'ש',
  'scheduler.duration.end': 'סיבת סיום',
  'scheduler.duration.endDate': 'תאריך סיום',
  'scheduler.duration.end.day': 'ביום זה',
  'scheduler.duration.end.after': 'אחרי',
  'scheduler.duration.end.no': 'ללא יום סיום',
  'scheduler.separator.and': ' ו',
  'scheduler.separator.on': 'ב־',
  'scheduler.separator.day': 'יום',
  'scheduler.separator.every': 'כל',
  'scheduler.separator.of': 'של',
  'scheduler.separator.the': 'ה',
  'scheduler.day.first': 'ראשון',
  'scheduler.day.second': 'שני',
  'scheduler.day.third': 'שלישי',
  'scheduler.day.fourth': 'רביעי',
  'scheduler.day.last': 'אחרון',
  'scheduler.weekday': 'יום חול',
  'scheduler.weekend': 'סוף שבוע',
  'scheduler.day': 'יום',
  'scheduler.days': 'ימים',
  'scheduler.week': 'שבוע',
  'scheduler.weeks': 'שבועות',
  'scheduler.year': 'שנה',
  'scheduler.years': 'שנים',
  'scheduler.monthDay': 'יום בחודש',
  'scheduler.month': 'חודש',
  'scheduler.months': 'חודשים',
  'scheduler.months.january': 'ינואר',
  'scheduler.months.february': 'פברואר',
  'scheduler.months.march': 'מרץ',
  'scheduler.months.april': 'אפריל',
  'scheduler.months.may': 'מאי',
  'scheduler.months.june': 'יוני',
  'scheduler.months.july': 'יולי',
  'scheduler.months.august': 'אוגוסט',
  'scheduler.months.september': 'ספטמבר',
  'scheduler.months.october': 'אוקטובר',
  'scheduler.months.november': 'נובמבר',
  'scheduler.months.december': 'דצמבר',
  'scheduler.months.short.january': 'ינו',
  'scheduler.months.short.february': 'פבר',
  'scheduler.months.short.march': 'מרץ',
  'scheduler.months.short.april': 'אפר',
  'scheduler.months.short.may': 'מאי',
  'scheduler.months.short.june': 'יונ',
  'scheduler.months.short.july': 'יול',
  'scheduler.months.short.august': 'אוג',
  'scheduler.months.short.september': 'ספט',
  'scheduler.months.short.october': 'אוק',
  'scheduler.months.short.november': 'נוב',
  'scheduler.months.short.december': 'דצמ',
  'scheduler.actions.manage': 'נהל מתזמן',
  'scheduler.meta.assignedTo': 'מוקצה ל־',
  'scheduler.meta.duration': 'משך',
  'scheduler.meta.period': 'תקופה',
  'scheduler.limited': 'המתזמן מוגבל ל־{{limit}}',
  'scheduler.info.helper': 'הגדר את המתזמן לתקופת מבצע.',
};
